/* global localStorage */
import ApiService from '@/common/api.service'

import { FECTH_SIDEBAR, FECTH_SHOW_SIDEBAR } from '@/store/actions.type'
import { SET_ERROR, SET_SIDEBAR, SET_SHOW_SIDEBAR } from '@/store/mutations.type'

const state = {
    showSidebar: true,
    sidebar: 'informes'
}

const getters = {
    getSidebar(state) {
        return state.sidebar
    },
    getShowSidebar(state) {
        return state.showSidebar
    }
}

const mutations = {
    [SET_SIDEBAR](state, sidebar) {
        state.sidebar = sidebar
        state.errors = {}
    },
    [SET_SHOW_SIDEBAR](state, sidebar) {
        state.showSidebar = showSidebar
        state.errors = {}
    },
}

const actions = {
    [FECTH_SIDEBAR](context, data) {
        context.commit(SET_SIDEBAR, data)
    },
    [FECTH_SHOW_SIDEBAR](context, data) {
        context.commit(SET_SIDEBAR, data)
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js